import { render, staticRenderFns } from "./AfterCreatePatientModal.vue?vue&type=template&id=61ccbc72&scoped=true&"
import script from "./AfterCreatePatientModal.vue?vue&type=script&lang=js&"
export * from "./AfterCreatePatientModal.vue?vue&type=script&lang=js&"
import style0 from "./AfterCreatePatientModal.vue?vue&type=style&index=0&id=61ccbc72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ccbc72",
  null
  
)

export default component.exports